import type { UserRepertoireData } from 'Types/RepertoireTypes';

export const isActiveProcessingStatus = (status: UserRepertoireData['status']): boolean =>
  status === 'queued' || status === 'processing';

export const isUserRepertoirePlayable = (
  repertoire: Pick<UserRepertoireData, 'status' | 'repertoire_png_preview_url'>,
): boolean =>
  !isActiveProcessingStatus(repertoire.status) &&
  repertoire.status !== 'failed' &&
  repertoire.status !== 'error' &&
  Boolean(repertoire.repertoire_png_preview_url);
